import { customerStatusLabel, customerStatusTone } from '../lib/status-labels.js';

/**
 * The one customer/deployment status badge, used everywhere (Customers list,
 * customer detail, dashboard). Replaces three divergent copies that each
 * rendered the raw status enum with inconsistent color coverage.
 */
export default function StatusBadge({ status }) {
  return <span className={`badge-${customerStatusTone(status)}`}>{customerStatusLabel(status)}</span>;
}
